import StyledModal from '@/components/StyledModal';
import { Button, ModalBody, ModalFooter, Text } from '@chakra-ui/react';
import rem from '@/utils/rem';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  okLabel: string;
};

const RecurringStatusBlockedModal = ({ isOpen, onClose, title, message, okLabel }: Props) => (
  <StyledModal isOpen={isOpen} onClose={onClose} size="xl" title={title}>
    <ModalBody>
      <Text color="text-secondary" fontSize="lg" fontWeight={500}>
        {message}
      </Text>
    </ModalBody>
    <ModalFooter justifyContent="flex-end" gap={rem(16)}>
      <Button onClick={onClose} size="lg" variant="primary">
        {okLabel}
      </Button>
    </ModalFooter>
  </StyledModal>
);

export default RecurringStatusBlockedModal;
